export default __webpack_public_path__ + "static/media/expedia2.269f18c3.png";